import React from 'react';
import { useDispatch } from 'react-redux';
import cs from 'classnames';
import { Field, Form, Formik } from 'formik';

import { userChanged } from 'features/users/hooks/user.slice';
import ModalFormHr from 'shared/components/atoms/ModalFormHr';
import { Box, Flex, Text } from 'shared/components/display';
import FormButton from 'shared/components/FormButton';
import Modal from 'shared/components/molecules/Modal';
import TextareaInput from 'shared/components/TextareaInput/TextareaInput';

import { apiAction } from 'shared/actions/api';
import { CREATOR_COPY, GENERIC_COPY } from 'shared/config/copy';
import { SIZING } from 'shared/config/formatting';
import { API_USER_ROUTES } from 'shared/config/routes/api/apiUserRoutes';
import { BUTTON_VARIANTS } from 'shared/styles/button';
import { CreatorUser } from 'shared/typings/user';

import { getValidationSchema, initialValues, MAX_REASON_LENGTH } from './config';
import styles from './styles';

interface Props {
  isOpen: boolean;
  onRequestClose?: () => void;
  user: CreatorUser;
}

const CreatorWarningStatusFormModal: React.FC<Props> = ({ isOpen, onRequestClose, user }) => {
  const dispatch = useDispatch();

  const onSubmit = (values) => {
    const { hasWarningStatus } = user;
    const { warningStatusReason } = values;

    dispatch(
      apiAction({
        path: {
          route: API_USER_ROUTES.WARNING_STATUS_CREATOR,
          variables: { userId: user.id },
        },
        method: 'PATCH',
        data: {
          hasWarningStatus: !hasWarningStatus,
          warningStatusReason,
        },
        successToast: {
          message: CREATOR_COPY.SUCCESS_WARNING_STATUS,
        },
        successAction: userChanged,
        onSuccess: onRequestClose,
      }),
    );
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      modalSize={SIZING.MEDIUM}
      title={CREATOR_COPY.PROMPT_WARNING_STATUS_USER}
      component={
        <Box css={styles} className={cs('creator-warning-status-form-modal')}>
          <Formik initialValues={initialValues} onSubmit={onSubmit} validationSchema={getValidationSchema()}>
            <Form>
              <Text className="creator-warning-status-form-modal__text">
                {CREATOR_COPY.PROMPT_WARNING_STATUS_USER_DETAIL}
              </Text>
              <Field
                name="warningStatusReason"
                component={TextareaInput}
                className="creator-warning-status-form-modal__textarea"
                dataCy="creator-warning-status-form-modal__textarea"
                placeholder={CREATOR_COPY.PLACEHOLDER_WARNING_STATUS_REASON}
                showCharactersCounter
                softMaxLength={MAX_REASON_LENGTH}
                maxLength={MAX_REASON_LENGTH}
              />
              <ModalFormHr />
              <Flex className={'creator-warning-status-form-modal__btn-wrapper'}>
                <FormButton type="button" onClick={onRequestClose} variant={BUTTON_VARIANTS.SECONDARY}>
                  {GENERIC_COPY.BUTTON_CANCEL}
                </FormButton>
                <FormButton type="submit" dataCy="creator-warning-status-form-modal__trend-btn">
                  Activate
                </FormButton>
              </Flex>
            </Form>
          </Formik>
        </Box>
      }
    />
  );
};

export default CreatorWarningStatusFormModal;
